import React, { useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Design } from '../../utils/formNames';
import { getFormData } from '../../utils/sessionStorage';
import { FORM_HOST, regularExpressions } from '../../utils/constants';
import EnrollmentForm from './EnrollmentForm';
import EnrollmentFormInput from '../FormInputs/FormInput';
import EnrollmentFormError from '../FormInputs/FormError';

const formName = Design;
const pardotFormUrl = `${FORM_HOST}/l/772833/2020-04-14/5c6zy8`;
const callbackLocations = {
  success_location: `${FORM_HOST}/l/772833/2020-07-06/7k97qz/772833/58635/design_success.js`,
  error_location: `${FORM_HOST}/l/772833/2020-07-06/7k97qx/772833/58633/design_error.js`,
};

const DesignForm = () => {
  const { register, handleSubmit, formState, triggerValidation, errors } = useForm({
    mode: 'onBlur',
    submitFocusError: false,
  });

  const { urlRegex } = regularExpressions;

  const previousData = getFormData(formName);

  const timer = useRef(null);
  const debounceTriggerValidation = () => {
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(triggerValidation, 650);
  };

  return (
    <EnrollmentForm
      formName={formName}
      callbackLocations={callbackLocations}
      actionUrl={pardotFormUrl}
      formValid={formState.isValid}
      validationHandler={handleSubmit}
    >
      <legend>UI/UX Design</legend>
      <EnrollmentFormInput
        name="design_portfolio"
        type="url"
        label="Please share a link to your portfolio or any other collection of your past work."
        placeholder="http://yourportfolio.com/"
        defaultValue={previousData.design_portfolio}
        inputRef={register({ required: true, pattern: urlRegex, maxLength: 255 })}
        required
        error={errors.design_portfolio}
        onChange={debounceTriggerValidation}
      />
      <EnrollmentFormError
        errorField={errors.design_portfolio}
        errorText={{ pattern: 'Please check that the url is correct.' }}
      />
    </EnrollmentForm>
  );
};

export default DesignForm;
